import { useState, useEffect } from "react";
import { storage } from "../utils/storage";

const CheckLoginStatus = () => {
  // Read token synchronously so the first paint already knows login state.
  // (Previously started as false and flipped in useEffect → race / redirect flash.)
  const [loginStatus, setLogin] = useState(
    () => !!storage.getItem("access_token"),
  );

  /**
   * Keep status in sync if storage changes (other tabs / login / logout)
   */
  useEffect(() => {
    const sync = () => {
      setLogin(!!storage.getItem("access_token"));
    };
    sync();
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);

  return { loginStatus };
};

export default CheckLoginStatus;
